<template>
    <div>
        <pdf v-if="pdfUrl" :pdfUrl="pdfUrl" ref="jsPdf"></pdf>
    </div>
</template>
<script>
import pdf from '@/components/pdf/index.vue'
export default {
    components: { pdf },
    data() {
        return {
            pdfUrl: '',
            id: ''
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getInfo(this.$route.query.id)

    },
    methods: {
        getInfo(id) {
            let data = {
                id: id,
                userId: this.$store.state.userId
            }
            this.apis.readCase(data).then(res => {
                console.log(res)
                this.pdfUrl = res.data
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/trial/pdf.vue